import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AsideInfoItemWrapper = styled.div`
  &:not(:last-of-type) {
    margin-bottom: ${Spacing.S8};
  }
`
